var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 166,
    viewBox: "0 0 132 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5476 3.45342C70.5825 0.430292 65.8001 0.158471 62.5108 2.82462C53.0095 10.5237 45.5097 15.3549 37.4543 18.7514C29.3661 22.1617 20.2867 24.3077 7.38169 26.1156C3.32671 26.684 0.310547 30.1479 0.310547 34.2375V93.7224C0.310547 106.016 5.6827 117.717 15.0395 125.637L56.9617 161.131C63.2108 166.419 72.3617 166.282 78.4496 160.817L117.859 125.438C126.672 117.526 131.687 106.185 131.687 94.3081V36.2431C131.687 32.3743 128.98 29.0326 125.193 28.2242C110.714 25.1311 101.141 22.2096 93.5698 18.5095C86.158 14.8876 80.302 10.338 73.5458 3.45566L73.5476 3.45342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.0dd1041e94dc584d0b08d33e633bc0c3.svg";
export { ForwardRef as ReactComponent };